/**
 * Newsletter Email Validator
 * Validates email format using the provided regex pattern
 */
class NewsletterEmailValidator {
  constructor() {
    this.init();
  }

  init() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    // Listen for newsletter form submissions
    document.addEventListener('submit', (e) => {
      const form = e.target;
      
      // Check if this is a newsletter form (footer or newsletter section)
      if (form.id === 'ContactFooter' || form.classList.contains('newsletter-form')) {
        const emailInput = form.querySelector('input[type="email"]');
        if (emailInput) {
          this.validateEmail(form, emailInput, e);
        }
      }
    });

    // Real-time validation on input
    document.addEventListener('input', (e) => {
      if (e.target.type === 'email' && 
          (e.target.closest('#ContactFooter') || e.target.closest('.newsletter-form'))) {
        this.realTimeValidation(e.target);
      }
    });
  }

  validateEmail(form, emailInput, event) {
    const email = emailInput.value.trim();
    
    if (!this.isValidEmail(email)) {
      event.preventDefault();
      this.showError(emailInput, 'Please enter a valid email address');
      return false;
    }
    
    return true;
  }

  realTimeValidation(emailInput) {
    const email = emailInput.value.trim();
    
    if (email.length > 0 && !this.isValidEmail(email)) {
      emailInput.setCustomValidity('Please enter a valid email address');
    } else {
      emailInput.setCustomValidity('');
    }
  }

  isValidEmail(email) {
    // Use the exact regex from your example
    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }

  showError(input, message) {
    input.setCustomValidity(message);
    input.reportValidity();
  }
}

// Initialize when DOM is loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new NewsletterEmailValidator();
  });
} else {
  new NewsletterEmailValidator();
}